var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrangeSliderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    transform: "rotate(-180 31 31)",
    fill: "#FF7925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1705 16.5541L39.5945 28.9657C39.7419 29.1135 39.8461 29.2735 39.9071 29.4459C39.969 29.6183 40 29.803 40 30C40 30.197 39.969 30.3817 39.9071 30.5541C39.8461 30.7265 39.7419 30.8865 39.5945 31.0343L27.1705 43.4828C26.8264 43.8276 26.3963 44 25.8802 44C25.3641 44 24.9217 43.8153 24.553 43.4459C24.1843 43.0765 24 42.6456 24 42.153C24 41.6605 24.1843 41.2296 24.553 40.8602L35.3917 30L24.553 19.1398C24.2089 18.7951 24.0369 18.3705 24.0369 17.8662C24.0369 17.3608 24.2212 16.9235 24.5899 16.5541C24.9585 16.1847 25.3886 16 25.8802 16C26.3717 16 26.8018 16.1847 27.1705 16.5541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrangeSliderArrowRight);
export default __webpack_public_path__ + "static/media/ic-orangeSliderArrowRight.ff7fd3953983b94837deb42327622460.svg";
export { ForwardRef as ReactComponent };